export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रीसेट"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सभी चुनें"])}
}